import React from "react";

const MaterialIcon = (props) => {
    return <span className={`unselectable material-icons ${props.className}`}>{props.icon}</span>;
};

export default MaterialIcon;
